import classNames from 'classnames';
import React from 'react';

import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';

interface SpinnerProps {
  classNames?: string;
  light?: boolean;
}

const Spinner = React.memo(
  (props: SpinnerProps): JSX.Element => (
    <div
      className={classNames('spinner', props.classNames, {'spinner-light': props.light})}
      {...loadingIndicatorAttrs()}
    />
  )
);

Spinner.displayName = 'Spinner';

export default Spinner;
